module.exports = __webpack_public_path__ + "img/img17.f5225948.svg";